<template>
<div>
    <div class="columns">
        <div class="column is-3">
            <div class="card">
                <div class="card-content has-text-centered">
                    <div class="title is-1" id="gtext">155</div>
                    <div class="subtitle">
                        Users
                    </div>
                </div>
            </div>

        </div>
        <div class="column is-3">
            <div class="card">
                <div class="card-content has-text-centered">
                    <div class="title is-1" id="gtext">17</div>
                    <div class="subtitle">
                        Chapters
                    </div>
                </div>
            </div>

        </div>
        <div class="column is-3">
            <div class="card">
                <div class="card-content has-text-centered">
                    <div class="title is-1" id="gtext">155</div>
                    <div class="subtitle">
                        Users
                    </div>
                </div>
            </div>

        </div>
        <div class="column is-3">
            <div class="card">
                <div class="card-content has-text-centered">
                    <div class="title is-1" id="gtext">17</div>
                    <div class="subtitle">
                        Chapters
                    </div>
                </div>
            </div>

        </div>
        
    </div>
    
   
    

</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
import Firestore from "../../lib/Firestore";
import dashboardService from './service.js'


export default {
    name: "dashboard",
    data() {
        return {
            upvoted: false,
            downvoted: false,
            votes: 0,
            topics: null,
            user: null,
            verifyModal: false,
            userId: null,
           
        }
    },
    computed: {

    },
    created() {
        

    },
    methods: {

    }

}
</script>

<style scoped>
.card {
    height: 100% !important;
}

.button {
    background: rgb(255, 193, 7);
    background: linear-gradient(90deg, rgba(255, 193, 7, 1) 0%, rgba(255, 68, 0, 1) 100%);
    color: white
}
#gtext{
     background: -webkit-linear-gradient(90deg, #070082, #0039da);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue